import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { playerStatsSelector } from '../../../../../../../store/js/modules/statspro/stats-leaders/selectors/player-stats-selector';
import { PlayerStatsTooltipHeader } from './PlayerStatsTooltipHeader';
import { PlayerStatsTooltipMainStat } from './PlayerStatsTooltipMainStat';
import { PlayerStatsTooltipRelatedStats } from './PlayerStatsTooltipRelatedStats';

/**
 * @param {object} props - Props.
 * @param {object} props.row - Row.
 * @param {object} props.cell - Cell.
 * @param {object} [props.benchmark] - Benchmark.
 * @returns {JSX.Element} Component.
 */
export const PlayerStatsTooltipContent = props => {
    const player = useSelector( playerStatsSelector )
        .find( _player => _player.details.playerId === props.row.player.playerId );

    return (
        <div>
            <PlayerStatsTooltipHeader player={ player } />
            <PlayerStatsTooltipMainStat { ...props } />
            <PlayerStatsTooltipRelatedStats
                { ...props }
                player={ player }
            />
        </div>
    );
};

PlayerStatsTooltipContent.propTypes = {
    row: PropTypes.object.isRequired,
    cell: PropTypes.object.isRequired,
    benchmark: PropTypes.string
};